import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import {
  DefaultButton,
  SubTitle2Text,
  SubTitle3Text,
  colors,
} from 'design-system';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexFlow: 'column',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    overflowY: 'auto',
    flexFlow: 'column',
    justifyContent: 'center',
  },
  footer: {
    padding: '20px 20px',
    backgroundColor: colors.onahau,
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  image: {
    marginTop: 20,
    marginBottom: 15,
  },
}));

const WaitingLayout = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Box className={classes.container} data-testid="waiting-layout-container">
      <Box className={classes.content}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <SubTitle2Text>Espere un momento...</SubTitle2Text>
          <img
            data-testid="waiting-layout-image"
            className={classes.image}
            src="/svg/updating_vin.svg"
            alt="updating vin"
          />
          <SubTitle3Text>Estamos actualizando los</SubTitle3Text>
          <SubTitle3Text>datos de la póliza</SubTitle3Text>
        </Box>
      </Box>

      <Box className={classes.footer}>
        <DefaultButton
          id="vin-modification-submit"
          fullWidth
          disabled
          data-testid="vin-modification-submit"
        >
          Actualizar &nbsp;&nbsp;&nbsp;
          <CircularProgress
            size={20}
            data-testid="button-loading"
            color="inherit"
          />
        </DefaultButton>
      </Box>
    </Box>
  );
};

export default WaitingLayout;
